import React from "react";
import AssociateInitiativesModal from "./AssociateInitiativesModal";
import {
  closeAssociateInitiativesModal,
  useAssociateInitiativesTrigger,
} from "./store";

export const AssociateInitiativesHost: React.FC = () => {
  const trigger = useAssociateInitiativesTrigger();
  if (!trigger) return null;
  return (
    <AssociateInitiativesModal
      trigger={trigger}
      onClose={closeAssociateInitiativesModal}
    />
  );
};

export {
  openAssociateInitiativesModal,
  closeAssociateInitiativesModal,
} from "./store";
